var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rateio',{attrs:{"servicos":_vm.obterServicos(),"permiteAtualizarRateio":_vm.$temAcessoView('SGTEC-UABS-ETP-02')}})
}
var staticRenderFns = []

export { render, staticRenderFns }